// js/core/Storage.js
// 客戶端進度保存：localStorage 自動快取 + 可匯出/匯入的「存檔碼」。
// 以 adapter 形式封裝，日後接後端只需替換實作，上層遊戲邏輯不變。

const LS_KEY = 'mrli.save.v1';
// 僅藏於前端，用來擋「隨手亂改」；非密碼學安全。伺服器權威留待 v2。
const SECRET = 'pbt-prototype-2026-client-only';

function defaultState() {
  return { v: 1, coffee: 0, materials: 0, levels: {} };
}

function b64urlEncode(str) {
  const b64 = btoa(unescape(encodeURIComponent(str)));
  return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
function b64urlDecode(s) {
  const pad = s.length % 4 ? '='.repeat(4 - (s.length % 4)) : '';
  const b64 = s.replace(/-/g, '+').replace(/_/g, '/') + pad;
  return decodeURIComponent(escape(atob(b64)));
}

// 簡易 keyed hash（FNV-1a + 混入密鑰）。非加密安全，僅供防呆。
function keyedHash(payload) {
  let h1 = 0x811c9dc5 >>> 0;
  let h2 = 0xdeadbeef >>> 0;
  const mix = payload + '|' + SECRET;
  for (let i = 0; i < mix.length; i++) {
    const c = mix.charCodeAt(i);
    h1 = Math.imul(h1 ^ c, 0x01000193) >>> 0;
    h2 = Math.imul(h2 + c, 2654435761) >>> 0;
  }
  for (let r = 0; r < 3; r++) {
    h1 = (Math.imul(h1 ^ h2, 0x01000193) ^ (h2 >>> 5)) >>> 0;
    h2 = (Math.imul(h2 ^ h1, 2654435761) ^ ((h1 << 7) >>> 0)) >>> 0;
  }
  return h1.toString(16).padStart(8, '0') + h2.toString(16).padStart(8, '0');
}

function encode(state) {
  const payload = b64urlEncode(JSON.stringify(state));
  return payload + '.' + keyedHash(payload);
}

function decode(code) {
  const parts = code.trim().split('.');
  if (parts.length !== 2) throw new Error('存檔碼格式不正確');
  const [payload, sig] = parts;
  if (keyedHash(payload) !== sig) throw new Error('存檔碼簽章不符（可能已損壞或遭竄改）');
  const state = JSON.parse(b64urlDecode(payload));
  if (!state || state.v !== 1) throw new Error('存檔版本不支援');
  return state;
}

export const Storage = {
  load() {
    try {
      const raw = localStorage.getItem(LS_KEY);
      return raw ? decode(raw) : defaultState();
    } catch (e) {
      console.warn('[Storage] 載入進度失敗，使用預設值：', e);
      return defaultState();
    }
  },

  save(state) {
    try {
      localStorage.setItem(LS_KEY, encode(state));
    } catch (e) {
      console.warn('[Storage] 儲存進度失敗：', e);
    }
  },

  exportCode(state) {
    return encode(state);
  },

  // 匯入：驗證簽章並回傳 state；失敗拋錯
  importCode(code) {
    return decode(code);
  },

  clear() {
    localStorage.removeItem(LS_KEY);
  },

  // 合併兩份進度：每關取較高星數、資源取較大值（用於匯入）
  merge(a, b) {
    const out = JSON.parse(JSON.stringify(a));
    out.coffee = Math.max(a.coffee || 0, b.coffee || 0);
    out.materials = Math.max(a.materials || 0, b.materials || 0);
    out.levels = out.levels || {};
    for (const id in b.levels || {}) {
      const nb = b.levels[id];
      const na = out.levels[id] || { stars: 0, completed: false };
      out.levels[id] = {
        stars: Math.max(na.stars || 0, nb.stars || 0),
        completed: !!(na.completed || nb.completed),
      };
    }
    return out;
  },
};
